<section class="logout-page">
  <div class="logout-card">
    <kendo-loader size="small"></kendo-loader>
    <h2>Signing you out...</h2>
    <p>Please wait while we close your session.</p>
  </div>
</section>
